import { render, staticRenderFns } from "./authorizeConfirm.vue?vue&type=template&id=7bb49aee&scoped=true"
import script from "./authorizeConfirm.vue?vue&type=script&lang=ts"
export * from "./authorizeConfirm.vue?vue&type=script&lang=ts"
import style0 from "./authorizeConfirm.vue?vue&type=style&index=0&id=7bb49aee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb49aee",
  null
  
)

export default component.exports